import React from "react";
import {OrbitComponent} from "../../base-components/orbit-component/orbit-component";
import {observer} from "mobx-react";
import {GameLoadingIndicatorRootBox} from "./boxes/game-loading-indicator-root.box";


export const GameLoadingIndicatorComponent = observer(class GameLoadingIndicatorComponent extends OrbitComponent {
    render() {

        const loadingIndicator = this.services.gameRunner.gameLoadingIndicator;

        if(!loadingIndicator) {
            return null;
        }

        return (
            <GameLoadingIndicatorRootBox isHidden={loadingIndicator.isHidden} zIndex={this.services.gameRunner.gameFrameZIndex}>
                {loadingIndicator.render()}
            </GameLoadingIndicatorRootBox>
        );
    }
});